// -----------------------------------------------------------------------------
// LossReasonModal — Raison de sortie d'un produit (vente, casse, périmé)
// StockPro / VisualisPro
// -----------------------------------------------------------------------------

import { getColors } from "../styles/theme";
import { Ic, ICONS } from "./Icons";

export default function LossReasonModal({
  product,
  dark,
  onSale,
  onLoss,
  onClose,
}) {
  const { textPrimary, textSecondary, borderColor } = getColors(dark);

  return (
    <div
      className="modal-bg"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div style={{ background:dark?"#0f0f1a":"#fff", border:`1px solid ${borderColor}`, borderRadius:18, padding:"22px", width:"100%", maxWidth:340, textAlign:"center" }}>
        <div style={{ width:46, height:46, background:"rgba(245,158,11,.1)", borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 12px" }}>
          <Ic d={ICONS.warn} size={22} color="#f59e0b" />
        </div>
        <div style={{ fontWeight:700, color:textPrimary, fontSize:15, marginBottom:4 }}>Raison de la sortie</div>
        <div style={{ color:textSecondary, fontSize:12, marginBottom:18 }}>{product.name}</div>
        <div style={{ display:"flex", flexDirection:"column", gap:9 }}>
          <button
            onClick={() => { onSale(product); onClose(); }}
            style={{ padding:"11px", borderRadius:10, background:"rgba(16,185,129,.1)", color:"#10b981", fontWeight:700, fontSize:14, border:"1px solid rgba(16,185,129,.2)", cursor:"pointer" }}
          >
            🛒 Vente / Utilisation
          </button>
          <button
            onClick={() => onLoss(product, "Jeté/Casse")}
            style={{ padding:"11px", borderRadius:10, background:"rgba(239,68,68,.1)", color:"#f87171", fontWeight:700, fontSize:14, border:"1px solid rgba(239,68,68,.2)", cursor:"pointer" }}
          >
            🗑️ Jeté / Casse
          </button>
          <button
            onClick={() => onLoss(product, "Périmé")}
            style={{ padding:"11px", borderRadius:10, background:"rgba(245,158,11,.1)", color:"#fbbf24", fontWeight:700, fontSize:14, border:"1px solid rgba(245,158,11,.2)", cursor:"pointer" }}
          >
            ⏰ Périmé
          </button>
          <button
            onClick={onClose}
            style={{ padding:"8px", borderRadius:10, background:"none", color:textSecondary, fontSize:13, border:"none", cursor:"pointer" }}
          >
            Annuler
          </button>
        </div>
      </div>
    </div>
  );
}
